
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { getUserListByRoleThunk } from "slices/userSlice";
import { useNavigate, useParams } from "react-router-dom";
import UserHostTable from "../tables/components/UserHostTable";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import { columnsDataColumnsUser } from "../tables/variables/columnsData";
import Card from "components/card";
import AddUserHostModal from "components/modals/addUserHostModal";
import PopUpAlertModal from "components/modals/popUpAlertModal";
import { deleteUserHostThunk } from "slices/userSlice";

const Marketplace = ({type}) => {
  const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageA, setPageA] = useState(1); // App Admin table
    const [pageB, setPageB] = useState(1); // Agent table
    const [open,setOpen]=useState(false);
    const [openAlert,setOpenAlert]=useState(false)
      const [singleData, setSingleData] = React.useState({});
      const [id,setId]=useState(null)
    const itemsPerPage = 5;
    const {appId}=useParams()
  const userDataList=useSelector((state) => state.users?.data?.data)?.map((item,index)=>{

    return {
      ...item,
      img_Url:item?.img_Url || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
    }
  }) || [];
  const userListOnly=userDataList?.filter((user)=>user?.isHost==false) || [];
  const hostListOnly=userDataList?.filter((user)=>user?.isHost==true) || [];
  const pagedAppAdmins = userListOnly?.slice(
  (pageA - 1) * itemsPerPage,
  pageA * itemsPerPage
);
const totalPagesA = Math.ceil(userListOnly.length / itemsPerPage);
const pagedAgents = hostListOnly?.slice(
  (pageB - 1) * itemsPerPage,
  pageB * itemsPerPage
);
const totalPagesB = Math.ceil(hostListOnly?.length / itemsPerPage);
 useEffect(() => {
  if (appId && appId !== ":appId") {
    dispatch(getUserListByRoleThunk(appId));
  } else {
    dispatch(getUserListByRoleThunk());
  }
}, [appId, dispatch]);
  const deleteUser=(id)=>{
    if(id){
    setId(id)

      setOpenAlert(true)

    }
  }
  return (
    <>

 
         <Card extra="mt-3 !z-5 overflow-hidden">
                    <div className="relative w-full flex items-center justify-end rounded-t-3xl p-3">
                        <button onClick={()=>setOpen(true)}
                            className=" top-3 right-3 flex items-center justify-center rounded-[9px] bg-[#422afb] p-2 text-white hover:cursor-pointer"
                        >
                            {type=="user" ? "Add user" :"Add Host"}
                        </button>
                    </div>
                </Card>
    <div className="mt-3 grid h-full grid-cols-1 gap-5 xl:grid-cols-1 2xl:grid-cols-1">
      <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">
    
        {type=="user" && pagedAppAdmins?.length > 0 && <div className="mb-4 mt-5 flex flex-col justify-between px-4 md:flex-row md:items-center">
          <h4 className="ml-1 text-2xl font-bold text-navy-700 dark:text-white">
            Users List
          </h4>
      
        </div>}
        {type=="user" && pagedAppAdmins?.length > 0 && <div>
          <UserHostTable
            title="User Table"
            columnsData={columnsDataColumnsUser}
            tableData={pagedAppAdmins?.length > 0 ? pagedAppAdmins : []}
            setOpen={setOpen}
         singleData={singleData} setSingleData={setSingleData}
         deleteUser={deleteUser}
          />
          {/* Pagination controls */}
          {totalPagesA > 1 && (
            <div className="flex gap-2 justify-center my-2">
              <button onClick={() => setPageA(p => Math.max(1, p - 1))} disabled={pageA === 1}>  <MdSkipPrevious /></button>
              {Array.from({ length: totalPagesA }, (_, i) => (
                <button key={i + 1} onClick={() => setPageA(i + 1)} className={i + 1 === pageA ? 'font-bold' : ''}>
                  {i + 1}
                </button>
              ))}
              <button onClick={() => setPageA(p => Math.min(totalPagesA, p + 1))} disabled={pageA === totalPagesA}>   <MdSkipNext /></button>
            </div>
          )}
        </div>}
        {/* <div className="z-20 grid grid-cols-1 gap-5 md:grid-cols-5">
          {
            userListOnly?.length>0 && userListOnly?.map((user, index) => (
    <NftCard
            bidders={[avatar1, avatar2, avatar3]}
            title={user?.name || "User Name"}
            author={user?.createdBy ? "admin": "Self"}
            price={user?.current_top_amount || "0.00"}
            image={user?.img_Url || NFt3}
            isHost={user?.isHost || false}
            gender={user?.gender }
            isDeleted={user?.isDeleted || false}
             email={user?.email || "No Email"}
            onClick={() => {
              navigate("/admin/user-details", {
                state: { userDetails: user }
              });
            }
          }
          />
            ))
          }
      
        </div> */}

        {/* Recenlty Added setion */}
        {type=="host" && pagedAgents?.length > 0 && <div className="mb-5 mt-5 flex items-center justify-between px-[26px]">
          <h4 className="text-2xl font-bold text-navy-700 dark:text-white">
           Host List
          </h4>
        </div>}
        {type=="host" && pagedAgents?.length > 0 && <div>
          <UserHostTable
            title="Host Table"
            columnsData={columnsDataColumnsUser}
            tableData={pagedAgents?.length > 0 ? pagedAgents : []}
            setOpen={setOpen} 
            singleData={singleData} setSingleData={setSingleData}
                  deleteUser={deleteUser}
          />
          {/* Pagination controls */}
          {totalPagesB > 1 && (
            <div className="flex gap-2 justify-center my-2">
              <button onClick={() => setPageB(p => Math.max(1, p - 1))} disabled={pageB === 1}>  <MdSkipPrevious /></button>
              {Array.from({ length: totalPagesB }, (_, i) => (
                <button key={i + 1} onClick={() => setPageB(i + 1)} className={i + 1 === pageB ? 'font-bold' : ''}>
                  {i + 1}
                </button>
              ))}
              <button onClick={() => setPageB(p => Math.min(totalPagesB, p + 1))} disabled={pageB === totalPagesB}>   <MdSkipNext /></button>
            </div>
          )}
        </div>}
        {/* Recently Add NFTs */}
          {/* <div className="z-20 grid grid-cols-1 gap-5 md:grid-cols-5">
          {
            hostListOnly?.length>0 && hostListOnly?.map((user, index) => (
    <NftCard
            bidders={[avatar1, avatar2, avatar3]}
            title={user?.name || "User Name"}
            author={user?.createdBy ? "admin": "Self"}
            price={user?.current_top_amount || "0.00"}
            image={user?.img_Url || NFt3}
            isHost={user?.isHost || false}
            gender={user?.gender }
            isDeleted={user?.isDeleted || false}
            email={user?.email || "No Email"}
                 onClick={() => {
              navigate("/admin/user-details", {
                state: { userDetails: user }
              });
            }
          }
          />
            ))
          }
      
        </div> */}
      </div>


 
    </div>
        <PopUpAlertModal openAlert={openAlert} setOpenAlert={setOpenAlert} title="Are you sure you want to delete this user?" clickHandler={()=>dispatch(deleteUserHostThunk(id))} />
    <AddUserHostModal open={open} setOpen={setOpen} type={type} singleData={singleData} setSingleData={setSingleData} />
    </>
  );
};

export default Marketplace;
